<template>
  <div
    @dragover.prevent="onFileDragover"
    @drop.prevent="onFileDragleave">
    <header-bar>
      {{ type === 'album' ? 'アルバム（2曲以上）': 'シングル' }}配信
    </header-bar>
    <div
      id="release-jacket"
      class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">リリース情報登録 - ジャケット画像の登録</h3>
        <release-type-label :type="type" />
      </div>
      <div class="page-block__inner">
        <release-step-area :index="2">
          ジャケット画像の登録<span>登録する商品のジャケット画像をアップロードしてください。</span>
        </release-step-area>
        <alert-view
          v-if="errorObject"
          :errors="errorObject" />
        <div class="release-jacket-area">
          <div class="release-jacket-area__pic">
            <img
              class="preview-image"
              :src="previewImage" />
          </div>
          <!-- drop後 -->
          <div class="release-jacket-area__text">
            <div
              v-if="previewImage && !dragOver"
              class="release-jacket-area__upload-box release-jacket-area__upload-box--on">
              <div class="release-jacket-area__upload-text">
                <span class="release-jacket-area__upload-text--bold">
                  {{ fileName }}
                </span>
              </div>
              <div class="release-jacket-area__upload-text">
                <span
                  v-if="!fileName"
                  class="release-jacket-area__upload-text--bold">
                  アップロードする画像ファイルをドロップ
                </span>
              </div>
              <a
                class="c-btn c-btn--release"
                href="#"
                @click.prevent="onUploadClicked">
                変更する
                <span class="c-btn__icon-arrow"></span>
              </a>
            </div>
            <!-- ドラッグ時 -->
            <div
              v-if="dragOver"
              class="release-jacket-area__upload-box drop-box-border"
              @keydown.esc="onFileDragleave"
              @drop.prevent="onFileDrop">
              <div class="release-jacket-area__upload-text">
                <span class="release-jacket-area__upload-text--bold">
                  ここに画像ファイルをドロップ
                </span>
              </div>
            </div>
            <!-- デフォルト -->
            <div
              v-if="!previewImage && !dragOver"
              :class="[{'error': errors.length}, 'release-jacket-area__upload-box']">
              <div class="release-jacket-area__upload-text pc">
                <span class="release-jacket-area__upload-text--bold">アップロードする画像ファイルをドロップ</span>
                &nbsp;&nbsp;または
              </div>
              <a
                class="c-btn c-btn--release"
                href="#"
                @click.prevent="onUploadClicked">
                画像ファイルを選択
                <span class="c-btn__icon-arrow"></span>
              </a>
            </div>
            <input
              ref="file"
              type="file"
              style="display:none"
              accept="image/*"
              @change="onFileChanged" />
            <div class="form--error">
              <p
                v-for="(error, index) in errors"
                :key="index"
                class="error-text">
                {{ error }}
              </p>
            </div>
            <ul class="c-indent-list">
              <li class="c-indent-list__node">ジャケット画像の登録は1枚のみとなります。</li>
              <li class="c-indent-list__node">配信ストアの規定により、ジャケット画像の登録がないと配信できないため必ず登録をお願いいたします。</li>
              <li class="c-indent-list__node">各配信ストアの判断により配慮できない場合がございますのでご了承ください。</li>
            </ul>
          </div>
        </div>
        <div class="release-caution-area">
          <div class="release-caution-area__paragraph">
            <p class="u-bold">1.ジャケット画像は以下の形式で作成・登録してください。</p>
            <ul class="c-indent-list">
              <li class="c-indent-list__node">
                JPG または PNG イメージファイル
              </li>
              <li class="c-indent-list__node">
                3000 x 3000 ピクセル以上の正方形 （6000×6000まで）
              </li>
              <li class="c-indent-list__node">
                RGB カラーモード (白黒含む) 注：CMYK は使用できません。
              </li>
              <li class="c-indent-list__node">
                20M以内
              </li>
            </ul>
          </div>
          <div class="release-caution-area__paragraph">
            <p class="u-bold">2.以下のような画像を使用することはできません。</p>
            <ul class="c-indent-list">
              <li class="c-indent-list__node">
                汎用的なアートテンプレート（単一色のみなど）
              </li>
              <li class="c-indent-list__node">
                他の楽曲のジャケット画像として使用しているもの
              </li>
              <li class="c-indent-list__node">
                著作権を侵害するような画像
              </li>
              <li class="c-indent-list__node">
                品質上の問題（画質が粗く文字や被写体の判別が困難、ピントがあっていない、空白が多い、途中でカットされている）
              </li>
              <li class="c-indent-list__node">
                値引きに関連している単語や表現の記載（「DVD 付き」、「歌詞付き」、「抽選」、「懸賞」、「セール価格」、「特価」、「奉仕価格」、「キャンペーン」）
              </li>
              <li class="c-indent-list__node">
                誤解を招く情報の記載があるもの（楽曲に無関係なアーティスト・ボーカル・演奏者などの記載）
              </li>
              <li class="c-indent-list__node">
                リリースと無関係な情報の記載があるもの、または登録されたリリースタイトル・アーティスト名と表記に差異があるもの
              </li>
              <li class="c-indent-list__node">
                各配信ストア名称・ロゴ等の情報、購入リンク及びURL、QRコードの記載（「iTunes Store」、「○○にて先行配信中」）
              </li>
              <li class="c-indent-list__node">
                ブランド名や広告の記載
              </li>
              <li class="c-indent-list__node">
                物理的商品に該当する単語や表現の記載（「CD」「Disc」「DVD」）
              </li>
              <li class="c-indent-list__node">
                デジタル商品に対応する単語や表現の記載（「Digital Exclusive」「Digital Version」）
              </li>
              <li class="c-indent-list__node">
                ポルノ写真及び、卑猥な画像
              </li>
              <li class="c-indent-list__node">
                ドイツ刑法典で規制されている全ての、ナチスの紋章（ハーケンクロイツ・卐・逆駒十字）や、ナチスに関連する単語や表現
              </li>
            </ul>
          </div>
        </div>
        <div
          class="confirm-checkbox-area guest-approve-checkbox-area">
          <div class="checkbox">
            <label>
              <input
                v-model="isChecked"
                type="checkbox">
              <div class="option-input"></div>
              第三者に権利のある画像を利用していない
            </label>
          </div>
        </div>
        <div class="c-btn-wrap">
          <a
            class="c-btn"
            :class="{ 'c-btn--off': (!validated || !isChecked) }"
            href="#"
            @click.prevent="onRegisterClicked">
            登録する
            <span class="c-btn__icon-arrow"></span>
          </a>
          <a
            class="c-btn c-btn--back c-btn--back-left"
            href="#"
            @click.prevent="onReturnClicked">
            戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span></a>
        </div>
      </div>
    </div>
    <release-check-list />
    <div
      v-if="dragOver"
      class="drop-zone"
      @dragleave.prevent="onFileDragleave">
    </div>
    <confirm-dialog
      name="imageEditor"
      :is-shown="imageEditorDialogShown"
      title="画像編集"
      default-button-title="切り取り実行"
      cancel-button-title="キャンセル"
      @closed="imageEditorDialogShown = false"
      @default-clicked="onEditorDefaultClicked"
      @cancel-clicked="onEditorCancelClicked">
      <template #body>
        <div
          class="alert-view mb-3"
          style="margin-bottom: 15px">
          縦横比が１対１の正方形になるように切り取って下さい
          <div class="hidden-pc-only">
            画像はピンチイン・ピンチアウトで<br />サイズを変更することが可能です
          </div>
        </div>
        <vue-cropper
          ref="cropper"
          :src="editingImage"
          alt="Source Image"
          :guides="true"
          :view-mode="2"
          drag-mode="move"
          :crop-box-resizable="true"
          :check-orientation="true"
          :aspect-ratio="1"
          :initial-aspect-ratio="1"
          :auto-crop="true"
          :auto-crop-area="autoCropArea"
          :background="true"
          :rotatable="true"
          :img-style="cropperImageStyle"
          :min-container-width="minContainerWidth"
          :min-container-height="minContainerHeight">
        </vue-cropper>
        <div class="hidden-sp-only">
          <button
            type="button"
            class="tool-button"
            @click.prevent="onZoomInButtonClicked">
            + 拡大
          </button>
          <button
            type="button"
            class="tool-button"
            @click.prevent="onZoomOutButtonClicked">
            - 縮小
          </button>
        </div>
        <div
          v-if="croppedError"
          class="cropped-error">
          {{ croppedError }}
        </div>
      </template>
    </confirm-dialog>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import base64ToBinary from '../../../../logic/image'
import ReleaseStepArea from '../StepArea'
import ReleaseCheckList from '../CheckList'
import HeaderBar from '../../HeaderBar'
import ReleaseTypeLabel from '../ReleaseTypeLabel'
import AlertView from '../../AlertView'
import ConfirmDialog from '../../../../components/ConfirmDialog'

export default {
  name: 'ReleaseStep2Jacket',
  components: {
    ConfirmDialog,
    ReleaseTypeLabel,
    HeaderBar,
    ReleaseCheckList,
    ReleaseStepArea,
    AlertView,
    VueCropper,
  },
  data() {
    return {
      croppedError: '',
      previewImage: null,
      validated: false,
      errors: [],
      type: '',
      dragOver: false,
      fileName: '',
      editingImage: '',
      imageEditorDialogShown: false,
      resized: false,
      autoCropArea: 0.8,
      isChecked: false,
    }
  },
  computed: {
    errorObject() {
      if (!this.errors.length) return null
      return {
        0: this.errors,
      }
    },
    cropperImageStyle() {
      return (window.innerWidth ?? 0) >= 896
        ? { width: '400px', height: '400px' }
        : { width: '280px', height: '280px' }
    },
    minContainerWidth() {
      return (window.innerWidth ?? 0) >= 896
        ? 600
        : 300
    },
    minContainerHeight() {
      return (window.innerWidth ?? 0) >= 896
        ? 360
        : 180
    },
  },
  mounted() {
    window.scrollTo(0, 0)
    const release = JSON.parse(window.sessionStorage.getItem('album'))
    this.type = release.type
    this.previewImage = release.jacketImage
  },
  methods: {
    // 戻るボタンクリック
    onReturnClicked() {
      window.scrollTo(0, 0)
      this.$router.push({ name: `${this.$route.meta.sideMenuId}-step2` })
    },
    // 登録ボタンクリック
    async onRegisterClicked() {
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      // 商品とジャケ写を紐付ける
      const base64String = this.previewImage.substr(this.previewImage.indexOf(',') + 1) // 先頭に制御文字があるので除去
      const formData = new FormData()
      const config = {
        headers: { 'content-type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent
          this.progressValue = Math.round((loaded / total) * 100)
          this.$store.dispatch('progress/updateLoaded', this.progressValue)
          this.$store.dispatch(
            'progress/updateText',
            `1個中の1個のファイルをアップロード中 (${this.progressValue}%)`,
          )
        },
      }
      formData.append('jacket', base64ToBinary(base64String))
      formData.append('resize', this.resized ? 1 : 0)
      try {
        await this.$store.dispatch('progress/reset')
        const { data } = await window.axios.post(`/api/client/products/${release.product.id}/jacket`, formData, config)
        release.product.coverart_filepath = data
        release.jacketImage = `/images/${data}`
        this.$store.dispatch('progress/reset')
        // セッションに保存して戻る
        window.sessionStorage.setItem('album', JSON.stringify(release))
        this.onReturnClicked()
      } catch ({ response }) {
        if (response.status === 422) {
          this.$store.dispatch('progress/reset')
          const { data } = response
          if (data.errors && data.errors.status) {
            this.errors = data.errors
            window.scrollTo(0, 0)
          }
        }
      }
    },
    // ファイル選択ボタンクリック
    onUploadClicked() {
      this.$refs.file.value = ''
      this.$refs.file.click()
    },
    // ファイル選択時コールバック
    onFileChanged(e) {
      const files = e.target.files || e.dataTransfer.files
      const reader = new FileReader()
      reader.onload = event => {
        this.checkImage(files[0], event)
      }
      reader.readAsDataURL(files[0])
    },
    // 画像のバリデーション
    async checkImage(file, event) {
      this.fileName = file.name
      this.$store.dispatch('progress/updateName', file.name)
      this.progressValue = 0
      const base64image = event.target.result
      this.errors = []
      this.croppedError = ''
      this.validated = false
      const formData = new FormData()
      const config = {
        headers: { 'content-type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent
          const progressValue = Math.round((loaded / total) * 100)
          this.$store.dispatch('progress/updateLoaded', progressValue)
          this.$store.dispatch(
            'progress/updateText',
            `1個中の1個のファイルをアップロード中 (${progressValue}%)`,
          )
        },
      }
      formData.append('jacket', file)
      const { data } = await window.axios.post('/api/client/image/validate/jacket', formData, config)
      this.$store.dispatch('progress/reset')
      if (data.result) {
        this.autoCropArea = 1
        this.previewImage = base64image
        this.validated = true
        this.resized = false
      } else {
        this.autoCropArea = 0.8
        this.errors = data.messages
        this.validated = false
        this.editingImage = base64image
        this.imageEditorDialogShown = true
      }
    },
    onFileDragover(event) {
      // eslint-disable-next-line no-param-reassign
      event.dataTransfer.dropEffect = 'copy'
      this.dragOver = true
    },
    onFileDragleave() {
      this.dragOver = false
    },
    onFileDrop(event) {
      this.dragOver = false
      this.onFileChanged(event)
    },
    onEditorDefaultClicked() {
      const data = this.$refs.cropper.getCroppedCanvas().toDataURL()
      if (data === 'data:,') {
        this.croppedError = 'このサイズでは切り取りできません。'
        return
      }
      this.previewImage = data
      this.errors = []
      this.validated = true
      this.imageEditorDialogShown = false
      this.resized = true
    },
    onEditorCancelClicked() {
      this.editingImage = ''
      this.imageEditorDialogShown = false
    },
    onZoomInButtonClicked() {
      this.$refs.cropper.relativeZoom(0.2)
    },
    onZoomOutButtonClicked() {
      this.$refs.cropper.relativeZoom(-0.2)
    },
  },
}
</script>

<style scoped>
@media screen and (min-width: 896px) {
  .preview-image {
    width: 240px;
    height: 240px;
  }
}

@media screen and (max-width: 895px) {
  .preview-image {
    width: 50vw;
    height: 50vw;
  }
}

.drop-zone {
  background: rgba(0, 0, 0, 0.8);
  left: 0;
  position: fixed;
  top: 0;
  z-index: 3;
  height: 100vh;
  width: 100vw;
}

.release-jacket-area__upload-box {
  z-index: 4;
}
.release-jacket-area__upload-box.error{
  background: #f2dede;
}

.drop-box-border {
  border: solid 3px #ff6c00;
}
.tool-button {
  padding: 5px 20px;
  width: 100px;
  background-color: gray;
  color: white;
  cursor: pointer;
}
.cropped-error {
  color: #a94442;
  background-color: #f2dede;
}
@media screen and (min-width: 895px) {
  .hidden-pc-only {
    display: none;
  }
}
@media screen and (max-width: 895px) {
  .hidden-sp-only {
    display: none;
  }
}

</style>
